import { observer } from 'mobx-react-lite';
import React, { useContext, useEffect, useState } from 'react';
import { Field, Form as FinalForm } from 'react-final-form';
import { RouteComponentProps } from 'react-router-dom';
import { combineValidators, isRequired } from 'revalidate';
import { Button, Form, Grid, Header, Segment } from 'semantic-ui-react';

import DateInput from '../../../app/common/form/DateInput';
import { formatParameterDisp } from '../../../app/common/util/util';
import { DepositSalesTicketFormValues } from '../../../app/models/depositSalesTicket';
import { RootStoreContext } from '../../../app/stores/rootStore';

const validate = combineValidators({
  limitMonthDate: isRequired({ message: '有効期限日は必須入力です' }),
});

interface DetailParams {
  id: string;
}

const DepositSalesTicketChangeLimitForm: React.FC<RouteComponentProps<
  DetailParams
>> = ({ match }) => {
  const rootStore = useContext(RootStoreContext);

  const {
    submitting,
    loadDepositSalesTicket,
    changeLimitDepositSalesTicket,
  } = rootStore.depositSalesTicketStore;

  const [formValues, setFormValues] = useState(
    new DepositSalesTicketFormValues()
  );
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (match.params.id) {
      setLoading(true);
      loadDepositSalesTicket(match.params.id).then((depositSalesTicket) => {
        depositSalesTicket.startDate = new Date(depositSalesTicket.startDate);
        depositSalesTicket.limitMonthDate = new Date(
          depositSalesTicket.limitMonthDate
        );
        setFormValues(new DepositSalesTicketFormValues(depositSalesTicket));
        setLoading(false);
      });
    }
  }, [loadDepositSalesTicket, match.params.id]);

  const handleFinalFormSubmit = (values: any) => {
    //画面選択項目をセット
    const { ...depositSalesTicket } = values;
    depositSalesTicket.limitMonthDate = formatParameterDisp(
      depositSalesTicket.limitMonthDate
    );
    changeLimitDepositSalesTicket(depositSalesTicket);
  };

  return (
    <Grid>
      <Grid.Column width={10}>
        <Segment clearing>
          <Header icon='calendar alternate' content='有効期限日の変更' />
          <FinalForm
            validate={validate}
            initialValues={formValues}
            onSubmit={handleFinalFormSubmit}
            render={({ handleSubmit, invalid, pristine }) => (
              <Form onSubmit={handleSubmit} loading={loading}>
                <Form.Group>
                  <Field
                    name='limitMonthDate'
                    label='有効期限日'
                    value={formValues.limitMonthDate}
                    component={DateInput}
                    minDate={formValues.startDate!}
                  />
                </Form.Group>
                <Button
                  loading={submitting}
                  disabled={loading || invalid || pristine}
                  floated='right'
                  positive
                  type='submit'
                  content='登録'
                />
              </Form>
            )}
          />
        </Segment>
      </Grid.Column>
    </Grid>
  );
};

export default observer(DepositSalesTicketChangeLimitForm);
